import { render, staticRenderFns } from "./MessageImage.vue?vue&type=template&id=3d22d8a0&"
import script from "./MessageImage.vue?vue&type=script&lang=js&"
export * from "./MessageImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports